<div class="form-group" *ngFor="let filter of settings">
  <app-datatable-filter-select (linksTo)="enableSelect($event)" (filtered)="preprocessFilter($event)" [filter]="filter" [enable]="enable"></app-datatable-filter-select>
</div>